import { useCallback, useContext } from "react";
import { useDatalayer } from "./use-datalayer";
import { datalayerModalContext } from "../components/datalayer-modal";

export const useDatalayerModalPush = () => {
    const { push: internalPush } = useDatalayer();
    const { action } = useContext(datalayerModalContext);
    const push = useCallback((label: string) => {
        internalPush({
            event: "virtualEvent",
            category: "Pacifico - Seguro Vida Ley",
            action,
            label,
        });
    }, []);
    return {
        push,
    };
};
